import { useAppDispatch } from '@/hooks/redux';
import { FeatureType } from '@/config/features';
import { msg } from '@/shared/helpers/msg';
import { emptyApi } from '@/store/emptyApi';

type InvalidateSingleTagParams = {
  type: FeatureType;
  container?: string | number;
  id?: string | number;
};

type InvalidateSingleTuple = [type: FeatureType, container?: string | number, id?: string | number];

type BulkInvalidateTagsParams = (InvalidateSingleTagParams | FeatureType | InvalidateSingleTuple)[] | FeatureType;

export const useInvalidateTags = (tags: BulkInvalidateTagsParams, notify?: boolean) => {
  const dispatch = useAppDispatch();

  return (withMessage?: unknown) => {
    dispatch(
      emptyApi.util.invalidateTags(
        typeof tags === 'string'
          ? [
              {
                type: tags,
              },
            ]
          : tags.map((tag) => {
              if (typeof tag === 'string') return { type: tag };

              if (Array.isArray(tag)) {
                const id = `${tag[1] || ''}${tag[2] || ''}`;
                return {
                  type: tag[0],
                  id,
                };
              }

              const obj: {
                type: FeatureType;
                id?: string;
              } = {
                type: tag.type,
              };

              if (tag.container || tag.id) {
                obj.id = `${tag.container || ''}${tag.id || ''}`;
              }

              return obj;
            }),
      ),
    );

    const sendNotification = typeof withMessage === 'boolean' ? withMessage : notify;

    sendNotification && msg.success('All data updated'); // UX! prevents reload the app
  };
};
